import { ApiIntegrationCategory } from '@app/_shared/enum/api-integration';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromIntegrations from './integrations.reducer';

export const selectIntegrationsState = createFeatureSelector<fromIntegrations.State>(
  fromIntegrations.integrationsFeatureKey,
);

export const selectSalesChannelIntegrations = createSelector(selectIntegrationsState, (state) =>
  state.apiIntegrations.filter((integration) => {
    return integration.attributes.category === ApiIntegrationCategory.Webshop;
  }),
);

export const selectSalesPaymentGatewayIntegrations = createSelector(selectIntegrationsState, (state) =>
  state.apiIntegrations.filter((integration) => {
    return integration.attributes.category === ApiIntegrationCategory.PaymentGateway;
  }),
);

export const selectAccountingIntegrations = createSelector(selectIntegrationsState, (state) =>
  state.apiIntegrations.filter((integration) => {
    return integration.attributes.category === ApiIntegrationCategory.Accounting;
  }),
);

export const selectAcquirerIntegrations = createSelector(selectIntegrationsState, (state) =>
  state.apiIntegrations.filter((integration) => {
    return integration.attributes.category === ApiIntegrationCategory.Acquirer;
  }),
);

export const selectMailerIntegrations = createSelector(selectIntegrationsState, (state) =>
  state.apiIntegrations.filter((integration) => {
    return integration.attributes.category === ApiIntegrationCategory.Mail;
  }),
);

export const selectBankIntegrations = createSelector(selectIntegrationsState, (state) =>
  state.apiIntegrations.filter((integration) => {
    return integration.attributes.category === ApiIntegrationCategory.Bank;
  }),
);

export const selectLoading = createSelector(selectIntegrationsState, (state) => state.loading);

export const selectSaving = createSelector(selectIntegrationsState, (state) => state.saving);

export const selectConnected = createSelector(selectIntegrationsState, (state) => state.connected);

export const selectError = createSelector(selectIntegrationsState, (state) => state.error);

export const selectDeleting = createSelector(selectIntegrationsState, (state) => state.deleting);
export const selectDeleted = createSelector(selectIntegrationsState, (state) => state.deleted);

export const hasShopifySalesChannel = createSelector(selectSalesChannelIntegrations, (integrations) => {
  return integrations.some((integration) => integration.attributes.platform === 'shopify');
});
